import React from 'react';
import { SubMenu } from './sub-menu.js';
import { MenuItemOption, Flex, Box, Checkbox, Spacer, MenuDivider, MenuItem as MenuItem$1, HStack } from '@chakra-ui/react';
import kebabCase from 'lodash/kebabCase.js';
import { Badge } from '../Badge/component.js';
import { BadgeVariant } from '../Badge/types.js';
import { Icon } from '../Icon/component.js';
import { Image } from '../Image/component.js';

var MenuItem = function MenuItem(_ref) {
  var _item$itemConfig3, _item$itemConfig5, _item$itemConfig6;

  var item = _ref.item,
      isMenuItemOptions = _ref.isMenuItemOptions,
      checkboxChange = _ref.checkboxChange,
      selectionCount = _ref.selectionCount;
  var hasSubmenu = item.items && item.items.length > 0;

  if (hasSubmenu) {
    var _item$items;

    var currentItem = {
      itemConfig: item.itemConfig,
      text: item.text,
      value: item.value
    };
    return /*#__PURE__*/React.createElement(SubMenu, {
      menuItem: currentItem,
      items: (_item$items = item.items) !== null && _item$items !== void 0 ? _item$items : [],
      isMenuItemOptions: isMenuItemOptions,
      checkboxChange: checkboxChange,
      selectionCount: selectionCount
    });
  }

  if (isMenuItemOptions) {
    var _item$itemConfig, _item$itemConfig2;

    return /*#__PURE__*/React.createElement(MenuItemOption, {
      icon: null,
      closeOnSelect: false,
      value: item.value
    }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Checkbox, {
      defaultChecked: false,
      value: item.value,
      onChange: checkboxChange
    }, ' ', !!item.text && item.text)), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Box, null, !!((_item$itemConfig = item.itemConfig) !== null && _item$itemConfig !== void 0 && _item$itemConfig.rightIconName) && /*#__PURE__*/React.createElement(Icon, {
      size: 'sm',
      iconName: (_item$itemConfig2 = item.itemConfig) === null || _item$itemConfig2 === void 0 ? void 0 : _item$itemConfig2.rightIconName
    }))));
  }

  if (item.isDivider) {
    return /*#__PURE__*/React.createElement(MenuDivider, null);
  }

  if ((_item$itemConfig3 = item.itemConfig) !== null && _item$itemConfig3 !== void 0 && _item$itemConfig3.href) {
    var _item$itemConfig4;

    return /*#__PURE__*/React.createElement(MenuItem$1, {
      onClick: item.onClick,
      as: "a",
      href: (_item$itemConfig4 = item.itemConfig) === null || _item$itemConfig4 === void 0 ? void 0 : _item$itemConfig4.href
    }, !!item.text && /*#__PURE__*/React.createElement(React.Fragment, null, " ", item.text, " "));
  }

  return /*#__PURE__*/React.createElement(MenuItem$1, {
    "data-action": kebabCase(item.text),
    onClick: item.onClick,
    closeOnSelect: !hasSubmenu,
    icon: ((_item$itemConfig5 = item.itemConfig) === null || _item$itemConfig5 === void 0 ? void 0 : _item$itemConfig5.iconName) && /*#__PURE__*/React.createElement(Icon, {
      iconName: (_item$itemConfig6 = item.itemConfig) === null || _item$itemConfig6 === void 0 ? void 0 : _item$itemConfig6.iconName
    })
  }, /*#__PURE__*/React.createElement(RegularMenuItem, {
    item: item
  }));
};

MenuItem.displayName = "MenuItem";

var RegularMenuItem = function RegularMenuItem(_ref2) {
  var _item$itemConfig7, _item$itemConfig8, _item$itemConfig9, _item$itemConfig10, _item$itemConfig11, _item$itemConfig12;

  var item = _ref2.item,
      selectionCount = _ref2.selectionCount;
  return /*#__PURE__*/React.createElement(HStack, null, !!((_item$itemConfig7 = item.itemConfig) !== null && _item$itemConfig7 !== void 0 && _item$itemConfig7.imagePath) && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Image, {
    path: (_item$itemConfig8 = item.itemConfig) === null || _item$itemConfig8 === void 0 ? void 0 : _item$itemConfig8.imagePath,
    width: '32px',
    height: '32px'
  })), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, !!item.text && item.text, !!((_item$itemConfig9 = item.itemConfig) !== null && _item$itemConfig9 !== void 0 && _item$itemConfig9.description) && /*#__PURE__*/React.createElement(Box, {
    as: "small",
    display: "block"
  }, (_item$itemConfig10 = item.itemConfig) === null || _item$itemConfig10 === void 0 ? void 0 : _item$itemConfig10.description)), selectionCount && /*#__PURE__*/React.createElement(Badge, {
    colorScheme: "neutral",
    variant: BadgeVariant.subtle
  }, selectionCount), !!((_item$itemConfig11 = item.itemConfig) !== null && _item$itemConfig11 !== void 0 && _item$itemConfig11.rightIconName) && /*#__PURE__*/React.createElement(Icon, {
    size: 'sm',
    iconName: (_item$itemConfig12 = item.itemConfig) === null || _item$itemConfig12 === void 0 ? void 0 : _item$itemConfig12.rightIconName
  }));
};

RegularMenuItem.displayName = "RegularMenuItem";
export { MenuItem, RegularMenuItem };